import React from 'react';
import ReactDOM from 'react-dom';


import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-datetime/css/react-datetime.css';
import 'react-tree-graph/dist/style.css'

import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/bundle.css';

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import App from './App.jsx';
import registerServiceWorker from './registerServiceWorker';


ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js